export default "__VITE_ASSET__DYupEMQd__"